/**
 * The channel a relation row's Detach action uses to reach the tab it is drawn
 * in — the same arrangement modelEditDialog.js describes, for the other action.
 *
 * BreadTabulatorActionDetachButton is mounted imperatively by the model's
 * column formatter (`new ComponentClass({ propsData, vuetify, store, router })`),
 * so it has no parent in the component tree and cannot `$emit` to the tab that
 * lists it. It IS handed the store, so the store is how it asks for a dialog.
 *
 * `hostCount` is what lets the same button keep routing to the detach PAGE
 * where nothing is listening (the legacy dev-model Tabulator pages), so this
 * change is additive for them.
 *
 * Deliberately NOT in the vuex-persist module list in store/index.js — a
 * half-open confirmation is not state worth restoring into the next session.
 */
export default {
  state: {
    data: {
      hostCount: 0,
      /**
       * The detach button's own props, verbatim, plus the row it was drawn on:
       * { serviceKey, parentModelKey, parentModelId, intermediateModelKey,
       *   intermediateModelId, childModelKey, row }
       * Consumed and cleared by the host.
       */
      request: null,
    },
  },
  getters: {
    //
  },
  actions: {
    registerModelDetachDialogHost(context) {
      context.commit("registerModelDetachDialogHost");
    },
    unregisterModelDetachDialogHost(context) {
      context.commit("unregisterModelDetachDialogHost");
    },
    requestModelDetach(context, data) {
      context.commit("requestModelDetach", data);
    },
    clearModelDetachRequest(context) {
      context.commit("clearModelDetachRequest");
    },
  },
  mutations: {
    registerModelDetachDialogHost(state) {
      state.data.hostCount += 1;
    },
    unregisterModelDetachDialogHost(state) {
      state.data.hostCount = Math.max(0, state.data.hostCount - 1);
    },
    requestModelDetach(state, data) {
      state.data.request = {
        serviceKey: data.serviceKey,
        parentModelKey: data.parentModelKey,
        parentModelId: data.parentModelId,
        intermediateModelKey: data.intermediateModelKey,
        intermediateModelId: data.intermediateModelId,
        childModelKey: data.childModelKey,
        row: data.row || null,
      };
    },
    clearModelDetachRequest(state) {
      state.data.request = null;
    },
  },
};
